module.exports = __webpack_public_path__ + "img/dashboard-status-bad.e44dc1e3.svg";